<template>
  <div
    class="image-walll w-full h-full border-solid border-1px rounded-10px border-[#EBEBEB] h-full p-10px py-5px bg-hex-$contentBgColor"
  >
    <column-header
      class="mb-10px"
      v-show="data.showTitle"
      :title="title"
      :showMore="data.showMore"
      @loadMore="loadMore"
    />
    <el-carousel
      :autoplay="false"
      arrow="never"
      indicator-position="none"
      class=" h-[calc(100%-50px)]"
    >
      <el-carousel-item v-for="item in Math.ceil(list.length / (row * col))" :key="item">
        <div class="h-full relative">
          <el-image
            v-for="(imgItem, index) in getGroupList(item - 1)"
            :key="imgItem.id"
            :src="`${fileUrl}${imgItem.imageFile}`"
            :fit="data.imageFit || 'fill'"
            class="cursor-pointer rounded-10px"
            :style="{
              marginLeft: index % col === 0 ? '0px' : '16px',
              height: `calc(100% / ${row} - 8px * ${row - 1} / ${row})`,
              width: `calc(100% / ${col} - 16px * ${col - 1} / ${col})`,
            }"
            @click="toDetail(imgItem)"
            ><div slot="error" class="image-slot"></div
          ></el-image>
        </div>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
import { ColumnTableApi, ColumApi } from '@wiz-api/workbench'
import addRequestQueue from '@/assets/js/RequestQueue'

const columnTableApi = new ColumnTableApi()
const columApi = new ColumApi()
const columnHeader = () => {
  return import('./ColumnHeader')
}
export default {
  props: {
    data: {
      type: Object,
      default: null,
    },
    mode: {
      type: String,
      default: 'update', // update/view   update模式不触发点击
    },
  },
  components: {
    columnHeader,
  },
  computed: {
    fileUrl() {
      const fileServer = Wiz.GetModuleServer('file-management')
      return `${fileServer}/api/file-management/files/public/image/`
    },
  },
  data() {
    return {
      page: {
        pageNo: 1,
        pageSize: 1,
        total: 0,
      },
      dataSource: '',
      list: [],
      title: '专题',
      row: 1,
      col: 1,
    }
  },
  methods: {
    loadMore() {
      if (this.mode !== 'update') {
        this.$router.push({
          path: `/portal/homepage?columnId=${this.data.dataSource}`,
        })
      }
    },
    getGroupList(index) {
      const num = this.row * this.col
      const startIndex = index * num
      return this.list.slice(startIndex, startIndex + num)
    },
    toDetail(row) {
      if (this.mode === 'update') {
        return
      }
      if (row.jumpType === 2) {
        row.skipMode === 1 ? window.open(row.url) : (window.location.href = row.url)
      } else if (row.jumpType === 1) {
        const path = `/portal/homepage?columnId=${row.jumpColumn}`
        row.skipMode === 1
          ? window.open(`${window.location.origin}${window.location.hash ? '/#' : ''}${path}`)
          : this.$router.push(path)
      }
    },
    async getTitle() {
      if (this.data.title && this.data.dataSource) {
        this.getListData()
        return
      }
      if (this.data.dataSource != null && this.data.dataSource !== '') {
        this.page.pageSize = this.data.pageSize
        const [err, res] = await columApi.getColumnDetail(this.data.dataSource)
        if (!err) {
          this.title = res.name
          this.getListData()
        }
      }
    },
    async getListData() {
      const params = {
        columnId: this.data.dataSource,
        isShow: true,
      }
      const [err, res] = await addRequestQueue(() => {
        return columnTableApi.getBinnerColumnTable(this.page.pageNo, this.page.pageSize, params)
      })
      if (!err && res) {
        this.list = []
        _.map(res.items, (it) => {
          it.isShow === true ? this.list.push(it) : ''
        })
        this.page.total = res.totalCount
      }
    },
  },
  created() {},
  watch: {
    data: {
      deep: true,
      immediate: true,
      handler(val, oldVal) {
        if (!_.isEmpty(val)) {
          this.row = val.row || 1
          this.col = val.col || 1
          this.title = val.title || '专题'
          if (
            val.dataSource !== this.dataSource ||
            val.pageSize !== this.page.pageSize ||
            val.row !== oldVal?.row ||
            val.col !== oldVal?.col
          ) {
            this.dataSource = val.dataSource
            this.page.pageSize = val.pageSize
            this.getTitle()
          }
        }
      },
    },
  },
}
</script>

<style lang="scss" scoped>
.image-walll {
  &::v-deep .el-carousel {
    .el-carousel__container {
      height: 100%;
    }
    .el-carousel__arrow {
      width: 30px;
      height: 40px;
      border-radius: unset;
      background-color: rgba(0, 0, 0, 0.3);
      &:hover {
        background-color: rgba(0, 0, 0, 0.4);
      }
    }
    .el-carousel__arrow--left {
      left: 0;
    }
    .el-carousel__arrow--right {
      right: 0;
    }
  }
}
</style>
